module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAbCAYAAAAH+20UAAAAAXNSR0IArs4c6QAAAG1JREFUWAntljEKgEAMBHMWVj7XL1ja6FO1sombzg8EVpjAwl1zDJPidmTmFhGrMivO8whuHwK+dFicST9s96TLqRS9+xTj4Q4JHwYwgAEMmBmor5ku0bgUukSjXJ7GAAYwgAEHA3SJ5i38r0u8aUgosU0RBjgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/menu_2x.png
// module id = 1744
// module chunks = 0